import { applyMiddleware, compose, legacy_createStore as createStore } from "redux";
import {persistStore} from 'redux-persist'
import thunk from "redux-thunk";
import reducer from "./reducer";
const composeEnhancers = process.env.REACT_APP_ENV === 'development'? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose):compose;
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)) );
const persistor = persistStore(store);
export default store;
export {persistor}